import React from "react";
import "./appreasalfour.css";

/**
 * AppraisalFour – headline + two-row detail grid (Uniqueness, Our Purpose)
 * - Uses your shared theme tokens: --bg, --ink, --muted, --accent, --pat
 * - Content customized for Emerald Appraisal Services
 */
export default function AppraisalFour() {
  return (
    <section className="A4" aria-labelledby="a4-title">
      <div className="A4__container">
        {/* Lead headline */}
        <h2 id="a4-title" className="A4__lead">
          <em>Emerald Appraisal Services</em> is committed to redefining{" "}
          <em>residential valuation</em> across the Greater Puget Sound. We take pride
          in delivering clear, well-supported opinions of value that exceed expectations.
        </h2>

        {/* Divider */}
        <hr className="A4__rule" />

        {/* Grid rows */}
        <div className="A4__rows" role="list">
          <div className="A4__row" role="listitem">
            <div className="A4__left">Uniqueness</div>
            <div className="A4__right">
              Our work is grounded in local market expertise across Pierce, King, Thurston, Grays Harbor
              Lewis, Mason, Kitsap, and Snohomish counties, USPAP-compliant methodology,
              and transparent, data-backed adjustments. Typical turnaround is
              <strong> 3–5 business days</strong> after the site visit, with rush options available.
              Lenders, attorneys, agents, investors, and homeowners trust our objective reporting
              for purchases, refinances, estate settlement, divorce, assessment appeal, and
              pre-listing decisions.
            </div>
          </div>

          <div className="A4__row" role="listitem">
            <div className="A4__left">Our Purpose</div>
            <div className="A4__right">
              We exist to make the appraisal process straightforward, credible, and well-supported.
              From manufactured homes and condos to small multi-family and unique properties,
              we synthesize recent comparable sales, market momentum, and property-specific
              characteristics to reach a conclusion you can confidently share with stakeholders.
              Accuracy, integrity, and clear communication are at the center of every report.
            </div>
          </div>
        </div>

        {/* Tail divider for visual parity */}
        <hr className="A4__rule A4__rule--tail" />
      </div>
    </section>
  );
}
